<script setup lang="ts">
const router = useRouter()
</script>

<template>
  <div class="border border-red-300 rounded-lg mb-8 -mt-2 w-full">
    <div class="bg-red-100 px-6 py-3 text-sm text-red-900">
      <p class="font-semibold">Cette page de dashboard est une ancienne version et ne sera bientôt plus disponible.</p>
      <p class="mt-1">
        Les chiffres affichés ici ne sont plus garantis à jour. Pour consulter vos données fiables et à jour, veuillez
        utiliser les nouveaux dashboards&nbsp;:
        <button
          type="button"
          class="font-semibold text-primary underline underline-offset-2 hover:text-primary/80"
          @click="router.push({ name: 'CockpitDashboard' })"
        >
          ouvrir le Cockpit des performances
        </button>
        .
      </p>
    </div>
  </div>
</template>
